function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m506.968 100.406h-80.124c-1.952 1.953-3.047 3.048-5 5-.015 194.414-.084 249.766.05 269.761 1.951 1.935 3.049 3.024 5 4.959h80.025c1.951-1.935 3.048-3.024 5-4.959.133-20.012.064-75.404.05-269.761-1.954-1.952-3.049-3.047-5.001-5z",
  fill: "#fcbe29"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m511.915 375.17s-2.36 2.334-5 4.96h-40.007v-279.72h40.057c1.96 1.95 3.05 3.04 5 5 .02 194.35.09 249.74-.05 269.76z",
  fill: "#fe9022"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m361.695.749h-331.666c-16.558 0-30.029 13.451-30.029 29.985v450.532c0 16.534 13.471 29.985 30.029 29.985h331.666c16.558 0 30.029-13.451 30.029-29.985v-450.532c0-16.534-13.471-29.985-30.029-29.985z",
  fill: "#edf5ff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m391.723 30.73v450.54c0 16.53-13.469 29.98-30.028 29.98h-165.829v-510.5h165.829c16.559 0 30.028 13.45 30.028 29.98z",
  fill: "#d5e8fd"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m76.122 360.438h151.303c8.284 0 14.999-6.716 14.999-15s-6.715-15-14.999-15h-151.303c-8.284 0-14.999 6.716-14.999 15s6.715 15 14.999 15z",
  fill: "#fc585a"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m242.423 345.44c0 8.28-6.72 15-14.999 15h-31.558v-30h31.558c8.28 0 14.999 6.71 14.999 15z",
  fill: "#fa195e"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m227.425 420.345h-151.303c-8.284 0-14.999 6.716-14.999 15s6.715 15 14.999 15h151.303c8.284 0 14.999-6.716 14.999-15s-6.716-15-14.999-15z",
  fill: "#ffda2d"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m242.423 435.35c0 8.28-6.72 15-14.999 15h-31.558v-30h31.558c8.28 0 14.999 6.71 14.999 15z",
  fill: "#fcbe29"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m76.122 270.438h151.303c8.284 0 14.999-6.716 14.999-15s-6.715-15-14.999-15h-151.303c-8.284 0-14.999 6.716-14.999 15s6.715 15 14.999 15z",
  fill: "#9cdd2b"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m242.423 255.44c0 8.28-6.72 15-14.999 15h-31.558v-30h31.558c8.28 0 14.999 6.71 14.999 15z",
  fill: "#67bb20"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m76.122 180.438h151.303c8.284 0 14.999-6.716 14.999-15s-6.715-15-14.999-15h-151.303c-8.284 0-14.999 6.716-14.999 15s6.715 15 14.999 15z",
  fill: "#30d9f6"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m242.423 165.44c0 8.28-6.72 15-14.999 15h-31.558v-30h31.558c8.28 0 14.999 6.71 14.999 15z",
  fill: "#19c0ef"
});

var _ref14 = /*#__PURE__*/React.createElement("g", {
  fill: "#112b48"
}, /*#__PURE__*/React.createElement("path", {
  d: "m324.942 213.094c-6.887-4.606-16.201-2.757-20.806 4.13l-10.767 16.101c-6.027-3.247-13.708-2.026-18.4 3.35-5.449 6.24-4.807 15.716 1.433 21.165l10.296 8.991c6.83 5.962 17.318 4.541 22.333-2.96l20.041-29.969c4.605-6.887 2.756-16.203-4.13-20.808z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m276.402 167.933 10.296 8.991c6.833 5.965 17.319 4.538 22.333-2.96l20.041-29.969c4.605-6.886 2.756-16.202-4.13-20.807-6.887-4.605-16.201-2.757-20.806 4.13l-10.767 16.101c-6.027-3.246-13.708-2.026-18.4 3.35-5.448 6.24-4.807 15.715 1.433 21.164z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m276.402 347.747 10.296 8.991c6.817 5.95 17.311 4.55 22.333-2.96l20.041-29.969c4.605-6.886 2.756-16.202-4.13-20.807-6.887-4.605-16.201-2.756-20.806 4.13l-10.767 16.101c-6.027-3.246-13.708-2.026-18.4 3.35-5.448 6.239-4.807 15.715 1.433 21.164z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m327.227 394.786c-5.85-5.868-15.348-5.882-21.211-.033l-4.441 4.428-4.441-4.428c-5.868-5.848-15.365-5.834-21.211.033-5.848 5.867-5.834 15.365.033 21.213l4.375 4.362-4.375 4.362c-5.867 5.849-5.881 15.346-.033 21.213 5.844 5.862 15.341 5.886 21.211.033l4.441-4.428 4.441 4.428c5.855 5.837 15.352 5.846 21.211-.033 5.848-5.867 5.834-15.365-.033-21.213l-4.375-4.362 4.375-4.362c5.866-5.849 5.881-15.346.033-21.213z"
}));

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m511.965 44.969c0-24.796-20.214-44.969-45.06-44.969s-45.059 20.173-45.059 44.969c0 21.511-.001 41.62-.002 60.437h90.123c-.002-18.818-.002-38.926-.002-60.437z",
  fill: "#fc585a"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m511.965 44.97v60.44h-45.057v-105.41c24.848 0 45.057 20.17 45.057 44.97z",
  fill: "#fa195e"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m422.282 378.719 30.06 121.874c1.652 6.7 7.663 11.408 14.562 11.408 6.9 0 12.91-4.708 14.562-11.408l30.06-121.874c.164-.664.273.296.344-3.592h-89.933c.073 3.862.182 2.93.345 3.592z",
  fill: "#fdd2a6"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "m511.875 375.13c0 3.378 2.891-9.55-30.408 125.46-1.65 6.7-7.659 11.41-14.559 11.41v-136.87z",
  fill: "#febd89"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "m257.982 61h-123.991c-8.284 0-14.999 6.716-14.999 15s6.715 15 14.999 15h123.991c8.284 0 14.999-6.716 14.999-15s-6.715-15-14.999-15z",
  fill: "#214c80"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "m272.981 76c0 8.28-6.72 15-14.999 15h-62.116v-30h62.116c8.28 0 14.999 6.72 14.999 15z",
  fill: "#193b66"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "m493.206 453c-1.169 4.761-11.378 46.13-11.739 47.59-1.65 6.7-7.659 11.41-14.559 11.41-6.899 0-12.909-4.71-14.569-11.41l-11.739-47.59z",
  fill: "#214c80"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "m493.216 453c-.111.421-11.645 47.168-11.749 47.59-1.65 6.7-7.659 11.41-14.559 11.41v-59z",
  fill: "#112b48"
});

var Svg018Review = function Svg018Review(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg018Review, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/018-review.d90954ac.svg";
export { ForwardRef as ReactComponent };